module.exports = __webpack_public_path__ + "static/media/binary_search_tree.3d675993.png";